import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isLogged: false,  
  token: null,
};

export const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    loginSuccess: (state, action) => {
      state.isLogged =  action.payload;      
    },    
    setToken: (state, action) => {
      state.token = action.payload; 
    },
    logout: (state) => {
      Object.assign(state, initialState);
    },   
  },
});

export const { loginSuccess, logout, setToken } = authSlice.actions;

export default authSlice.reducer;
